export default function newImportCsv(paramData) {
    const module = paramData.module;

    window.location.hash = "#import/" + module;
}